// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607301059/js/" + chunkId + "." + {"44":"af625b12","225":"6886e5c6","481":"d39ff29a","486":"9712dc09","770":"d5529c0a"}[chunkId] + ".0.18628261620953757.chunk.js";
};